import { useEffect } from 'react';
import Router from 'next/router';
import JsCookies from 'js-cookie';
import { Modal } from '@/components';
import { commonStore } from '@/stores/quick-order';

const useRootRouter = () => {

 useEffect(() => {
  Router.events.on('routeChangeComplete', () => {
    Modal.destroyAll();
    commonStore.isOpenLogin = false;
  });

  
  Router.events.on('routeChangeStart', (e) => {
    JsCookies.set('__regain_app_config', 'router_start');
  });
  
 }, [])
}

export default useRootRouter;